import React, { PureComponent, Fragment } from 'react';
import { Typography } from '@material-ui/core';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

class DatePicker extends PureComponent {
    render() {
        const {
            disabled,
            pickerData,
            makeDateHandler,
        } = this.props;

        return (
            <Fragment>
                <div style={{ display: 'flex' }}>
                    <div style={{ width: 55, paddingTop: 18, marginRight: '8px' }}>
                        <Typography variant="body2">
                            Between
                        </Typography>
                    </div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            disableToolbar
                            disabled={disabled}
                            autoOk
                            placeholder="Any Date"
                            inputVariant="outlined"
                            variant="inline"
                            format="MM/dd/yyyy"
                            margin="dense"
                            id={pickerData[0].key}
                            value={pickerData[0].stateVariable}
                            onChange={makeDateHandler(pickerData[0].key)}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                <div style={{ display: 'flex' }}>
                    <div style={{ width: 55, paddingTop: 18, marginRight: '8px' }}>
                        <Typography variant="body2">
                            and
                        </Typography>
                    </div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            disableToolbar
                            disabled={disabled}
                            autoOk
                            placeholder="Any Date"
                            inputVariant="outlined"
                            variant="inline"
                            format="MM/dd/yyyy"
                            margin="dense"
                            id={pickerData[1].key}
                            value={pickerData[1].stateVariable}
                            onChange={makeDateHandler(pickerData[1].key)}
                        />
                    </MuiPickersUtilsProvider>
                </div>
            </Fragment>
        )
    }
}

export default DatePicker
